import { CreditCardType } from '@anm/api/modules/subscription';
import CardDetails from '@anm/components/credit-card/CardDetails';
import ApplyCoupon from '@anm/components/form/ApplyCoupon';
import noop from 'lodash/fp/noop';
import { FC } from 'react';

import {
  CardDetailsBlock,
  CardDetailsCouponBlockWrapper,
  ChangeCardButton,
  ChangeCardCouponBlock
} from './Wrapper';

export type CardDetailsCouponBlockProps = {
  coupon: string;
  cardType: CreditCardType;
  cardLast4: string;
  onChangeCard: () => void;
  onCouponApply: () => void;
};

const CardDetailsCouponBlock: FC<CardDetailsCouponBlockProps> = ({
  cardType,
  cardLast4,
  onChangeCard = noop,
  onCouponApply = noop
}) => {
  return (
    <CardDetailsCouponBlockWrapper>
      <CardDetailsBlock>
        <CardDetails last4={cardLast4} cardType={cardType} />
      </CardDetailsBlock>

      <ChangeCardCouponBlock>
        <ChangeCardButton
          variant="blue-link"
          size="medium"
          onClick={onChangeCard}
        >
          Change card
        </ChangeCardButton>
        <ApplyCoupon onApply={onCouponApply} />
      </ChangeCardCouponBlock>
    </CardDetailsCouponBlockWrapper>
  );
};

export default CardDetailsCouponBlock;
